export default "__VITE_ASSET__CvA7vpBl__"